<h2 mat-dialog-title>Password Update Required</h2>
<mat-dialog-content>
    <div class="expiry-warning">
        <mat-icon color="warn">warning</mat-icon>
        <span>Your password has expired. Please create a new one.</span>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <!-- New Password -->
        <mat-form-field appearance="outline">
            <mat-label>New Password</mat-label>
            <input matInput formControlName="newPassword"
                   [type]="hideNew ? 'password' : 'text'">
            <button mat-icon-button matSuffix type="button"
                    (click)="hideNew = !hideNew">
                <mat-icon>{{hideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="form.get('newPassword')?.hasError('required')">
                Please Enter New Password
            </mat-error>
            <mat-error *ngIf="form.get('newPassword')?.hasError('invalidPassword')">
                Password does not meet requirements. See below.
            </mat-error>
        </mat-form-field>

        <!-- Password Requirements List -->
        <div *ngIf="form.get('newPassword')?.dirty" class="password-hints">
            <mat-hint>Password must contain:</mat-hint>
            <ul>
                <li *ngIf="minimumChars !== null"
                    [class.valid]="hasValidMinLength">
                    At least {{ minimumChars }} characters long
                </li>
                <li *ngIf="maximumChars !== null"
                    [class.valid]="hasValidMaxLength">
                    At most {{ maximumChars }} characters long
                </li>
                <li *ngIf="uppercaseReq !== null"
                    [class.valid]="hasUpperCase">
                    At least {{ uppercaseReq }} uppercase letter ( A-Z )
                </li>
                <li *ngIf="lowercaseReq !== null"
                    [class.valid]="hasLowerCase">
                    At least {{ lowercaseReq }} lowercase letter ( a-z )
                </li>
                <li *ngIf="numberReq !== null"
                    [class.valid]="hasNumber">
                    At least {{ numberReq }} number ( 0-9 )
                </li>
                <li *ngIf="specialChars"
                    [class.valid]="hasSpecialChar">
                    At least {{ specialCharReq }} special character ( {{ specialChars }} )
                </li>
                <li *ngIf="disallowedSpecialChars"
                    [class.valid]="!hasInvalidSpecialChar">
                    Does not contain any invalid characters ( {{ disallowedSpecialChars }} )
                </li>
                <li *ngIf="commonStrings?.length > 0"
                    [class.valid]="!containsCommonStrings">
                    Does not contain any common combinations ({{ commonStrings }})
                </li>
                <li *ngIf="(allowDictionaryWords === null || allowDictionaryWords === false) && (maxDictionaryWordLength > 1)"
                    [class.valid]="!containsDictionaryWord || allowDictionaryWords">
                    Does not contain dictionary words ({{ maxDictionaryWordLength }}+ letters)
                </li>
                <li *ngIf="sequenceNum !== null"
                    [class.valid]="!consecutiveChars">
                    No more than {{sequenceNum - 1}} identical consecutive characters
                </li>
                <li *ngIf="prevPasswordsChecked !== null" class="neutral">
                    Password must not match any of your last {{ prevPasswordsChecked }} passwords
                </li>
                <li class="neutral">
                    Password must not contain your name, email, or ID
                </li>
            </ul>
        </div>

        <!-- Confirm Password -->
        <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="confirmPassword"
                   [type]="hideConfirm ? 'password' : 'text'"
                   (input)="checkPasswords()">
            <button mat-icon-button matSuffix type="button"
                    (click)="hideConfirm = !hideConfirm">
                <mat-icon>{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="showConfirmPasswordError()">
                {{ getConfirmPasswordError() }}
            </mat-error>
        </mat-form-field>

        <div class="dialog-actions">
            <button 
                mat-raised-button 
                (click)="closeDialog()" 
                class="cancel-button"
            >
                Cancel
            </button>

            <button 
                mat-raised-button color="primary"
                type="submit" 
                [disabled]="form.invalid"
            >
                Update Password
            </button> 
        </div>
    </form>
</mat-dialog-content>